import { useTheme } from '@mui/material';

export const IntroIcon1 = ({ className }: { className: string }) => {
    const theme = useTheme();
    const primaryIconStrokeColor = theme.colors.other.icon.stroke.primary;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="49"
            viewBox="0 0 48 49"
            className={className}
        >
            <path
                fill={primaryIconStrokeColor}
                d="M23.2187 10.3492C23.7187 10.1367 24.2812 10.1367 24.7812 10.3492L35.825 15.0367C36.5312 15.3367 37.0062 16.0055 37 16.7617C36.9687 22.6367 34.5375 32.9992 24.7812 37.668C24.2875 37.9055 23.7062 37.9055 23.2125 37.668C13.4562 32.993 11.0312 22.6305 11 16.7555C10.9937 15.9992 11.4687 15.3305 12.175 15.0305L23.2187 10.343V10.3492ZM25.5625 8.50546C24.5625 8.08046 23.4375 8.08046 22.4375 8.50546L11.3937 13.193C10.0187 13.7742 8.99375 15.1305 9 16.768C9.03125 22.968 11.5812 34.3117 22.35 39.468C23.3937 39.968 24.6062 39.968 25.65 39.468C36.4187 34.3117 38.9687 22.968 39 16.768C39.0062 15.1305 37.9812 13.7742 36.6062 13.193L25.5625 8.50546ZM30.7062 20.7242C31.0937 20.3367 31.0937 19.6992 30.7062 19.3117C30.3187 18.9242 29.6812 18.9242 29.2937 19.3117L22 26.6055L18.7062 23.3117C18.3187 22.9242 17.6812 22.9242 17.2937 23.3117C16.9062 23.6992 16.9062 24.3367 17.2937 24.7242L21.2937 28.7242C21.6812 29.1117 22.3187 29.1117 22.7062 28.7242L30.7062 20.7242Z"
            />
        </svg>
    );
};
